import { Box } from "@mui/material";
import { ReactElement } from "react";
import { DashboardHeader } from "./styles";

type Props = {
  title: string;
  action?: ReactElement;
};

const DashboardHeaderRow = ({ title, action }: Props) => (
  <Box display="flex" justifyContent="space-between" alignItems="center">
    <DashboardHeader variant="header">{title}</DashboardHeader>
    {action}
  </Box>
);

export default DashboardHeaderRow;
